export enum DistributionTiming {
    Early, OnTime, Late, Both, None
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/distribution-timing.ts